// apps/api/src/qxcircle/qxcircle-account.ts
// Description: QXCircle author identity from registered account session.
// Owner: Masa Bayu
// Date: 2026-08-30

import type { AccountBundle } from "../account/account-types";

export type QxCircleAuthor = {
  accountId: string;
  authorName: string;
  authorHandle: string;
};

export function qxCircleAuthorFromAccount(account: AccountBundle): QxCircleAuthor {
  const authorName =
    account.profile.displayName.trim() ||
    account.user.email.split("@")[0]?.trim() ||
    "Member";
  const slug =
    authorName
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_|_$/g, "")
      .slice(0, 24) || "member";
  const suffix = account.user.id.replace(/-/g, "").slice(-6);
  return {
    accountId: account.user.id,
    authorName,
    authorHandle: `@${slug}_${suffix}`,
  };
}
